import React from "react";
import { Modal } from "react-bootstrap";
import { isMobile } from 'react-device-detect';
import manoramalogo from "../../assets/images/manorama_max_logo_dark_bg.png";
import actionbar_logo_light_theme from "../../assets/images/actionbar_logo_light_theme.png";
export default function subscribeAlertPopup(props) {
    return(
        <Modal
          show={props.subscribeAlertPopup}
          onHide={props.modalonHide}
          className="modal_infomsg mobile_signin subscription_content_alertbox"
        >
          <Modal.Header closeButton>
          <img
                    alt="logo"
                    src={manoramalogo}
                    className="mainlogo_mobile mainlogo_dark"
                  />
          </Modal.Header>
          <Modal.Body>
          <div className={`info_title ${props.popupType && props.popupType === 'adBlocker' ? 'adblockerTitle' : ''}`}>{props.adBlockerTitle ? props.adBlockerTitle : ''}</div>
            <div className="info_body">{props.message}</div>
            <div className="subscription_alertbox">
              <button onClick={() => props.clickSubscribe()} type="button" className="subscription_btn">{props.adBlockerButtonText ? props.adBlockerButtonText : 'Subscribe' } </button>
            </div>
          </Modal.Body>

          <Modal.Footer className="info_footer">
            <footer>
            </footer>
          </Modal.Footer>
        </Modal>
    );
}